import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {articleSessionTab_template} from "./articleSessionTab_template";
import {TargetType} from "../../utils/types/article_target";
import {ArticleSessionInterface} from "./articleSessionInterface";

declare var ko: any;
declare var page: any;

export class articleSessionView_template extends vnTemplate implements ArticleSessionInterface {

    protected successArticleSessionTab: articleSessionTab_template;
    protected failureArticleSessionTab: articleSessionTab_template;

    protected getTemplateName(): string {
        return "articleSessionView_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div id="session-target-list-results" class="w-form">
            
                <div class="form-header" >
                    <h3 class="form-title icon i-target">Article Session Thresholds</h3>
                    <button data-bind="event: {click: onClickEdit}" class="btn icon light" type="button">Edit</button>
                </div>
                <div class="form-pagination">
                    <button class="btn icon i-notice-success" type="button" data-bind="event: { click: onClickTab.bind($data,'success') }, css: { 'is-activated' : selectedType() == 'success'}"><span class="btn-text">Success Threshold</span></button>
                    <button class="btn icon i-notice-alert" type="button" data-bind="event: { click: onClickTab.bind($data,'failure') }, css: { 'is-activated' : selectedType() == 'failure'}"><span class="btn-text">Failure Threshold</span></button>
                </div>
                <div class="" data-bind="visible: (selectedType() == 'success')">
                    ${this.successArticleSessionTab.getHtmlBuild()}
                </div>
                <div class="" data-bind="visible: selectedType() == 'failure'">
                    ${this.failureArticleSessionTab.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            selectedType: ko.observable(TargetType.SUCCESS),
            contentTypes: ko.observableArray([]),
            onClickTab: (value, data, event): void => {
                self.onClickTab(value);
            },
            onClickEdit: (data, event): void => {
                self.onClickEdit();
            }
        };
    }

    protected initPartial() {
        this.successArticleSessionTab = new articleSessionTab_template('successArticleSessionTab', this.getTemplateViewModel(), this.caller);
        this.successArticleSessionTab.setParent(this);
        this.successArticleSessionTab.isReadOnly(true);
        this.successArticleSessionTab.setType(TargetType.SUCCESS);

        this.failureArticleSessionTab = new articleSessionTab_template('failureArticleSessionTab', this.getTemplateViewModel(), this.caller);
        this.failureArticleSessionTab.setParent(this);
        this.successArticleSessionTab.isReadOnly(true);
        this.failureArticleSessionTab.setType(TargetType.FAILURE);
        this.failureArticleSessionTab.setSaveFallback(true);

    }

    protected onClickTab(tab): void {
        this.getTemplateViewModel().selectedType(tab);
    }

    public setListingSessionTargets(sessionTargets: { success: any, failure: any }): void {

        if (sessionTargets.success) {
            this.successArticleSessionTab.setListingSessionTargets(sessionTargets.success);
        }
        if (sessionTargets.failure) {
            this.failureArticleSessionTab.setListingSessionTargets(sessionTargets.failure);
        }
    }

    public onClickEdit(): void {
        page('/analytics/article-session-thresholds/edit')
    }


    /** Session target brand year dropdown **/
    public setYearSelector(years, currentYear): void {

        if (this.isFailureSelected()) {

            this.successArticleSessionTab.setYearSelector(years, currentYear);
        } else {

            this.failureArticleSessionTab.setYearSelector(years, currentYear);
        }
    }

    public setYearsOnSuccessConfig(years, currentYear): void {

        this.successArticleSessionTab.setYearSelector(years, currentYear);
    }

    public setYearsOnFailureConfig(years, currentYear): void {

        this.failureArticleSessionTab.setYearSelector(years, currentYear);
    }

    public setContentTypes(contentTypes): void {
        this.getTemplateViewModel().contentTypes(contentTypes);
    }

    public getContentTypes() {
        return this.getTemplateViewModel().contentTypes();
    }

    public getYearSelector(): string {

        if (this.isFailureSelected()) {

            return this.failureArticleSessionTab.getYearSelector();
        } else {

            return this.successArticleSessionTab.getYearSelector();
        }
    }

    public getSelectedType(): string {
        return this.getTemplateViewModel().selectedType();
    }

    public isFailureSelected(): boolean {
        let selectedType = this.getSelectedType();

        return (selectedType == TargetType.FAILURE);
    }

    /**
     * Returns a list of session brands to be saved in the system
     */
    public getViewModelForRequest() {

        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.getViewModelForRequest();
        } else {
            return this.successArticleSessionTab.getViewModelForRequest();
        }
    }


    public setSuccessSelectedYearBrand(selectedYear): void {
        this.successArticleSessionTab.setSelectedYear(selectedYear);
    }

    public setFailureSelectedYearBrand(selectedYear): void {
        this.failureArticleSessionTab.setSelectedYear(selectedYear);
    }

    public setSelectedYearBrand(selectedYear): void {
        if (this.isFailureSelected()) {
            this.setFailureSelectedYearBrand(selectedYear);
        } else {
            this.setSuccessSelectedYearBrand(selectedYear);
        }
    }

    public toggleBrandSaveDialogVisibility() {

        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.toggleBrandSaveDialogVisibility();
        } else {
            return this.successArticleSessionTab.toggleBrandSaveDialogVisibility();
        }
    }

    /**
     * Toggle the dialog for displaying confirmation on deleting a content type exception
     */
    public toggleBrandContentTypeSaveDialogVisibility() {
        document.getElementById('dialog-brand-content-type-save').classList.toggle('is-visible');
    }

    public toggleContentTypeDeleteDialogVisibility() {
        document.getElementById('dialog-content-type-delete').classList.toggle('is-visible');
    }

    public hasUnsavedBrandSessionTarget() {
        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.hasUnsavedBrandSessionTarget();
        } else {
            return this.successArticleSessionTab.hasUnsavedBrandSessionTarget();
        }
    }
    public getSelectedYear() {
        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.getSelectedYear();
        } else {
            return this.successArticleSessionTab.getSelectedYear();
        }
    }
    public hasUnsavedContentTypes() {

        if (this.isFailureSelected()) {
            return this.failureArticleSessionTab.hasUnsavedContentTypes();
        } else {
            return this.successArticleSessionTab.hasUnsavedContentTypes();
        }
    }

    public setFallback(fallback: number): void {
        this.failureArticleSessionTab.setFallback(fallback);
    }

    public redirectToView(): void {}


}


// WEBPACK FOOTER //
// ./js/components/templates/articleSessionView_template.ts